module.exports = __webpack_public_path__ + "img/thumb_Late.15f98e6b.jpg";